import { CountrySelect } from "@/Common/Components/Contacts/CountrySelect";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { SelectLookupControl } from "@/Common/Components/Inputs/SelectLookupControl";
import { TextAreaResizable } from "@/Common/Components/Inputs/TextAreaResizable";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { TextboxMaskedControl } from "@/Common/Components/Inputs/TextboxMaskedControl";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";
import { EmployeeType } from "@/Common/Models/Employee/Enums/EmployeeType";
import { BaseEditableUserInfoPanelProps } from "./UserDetailsPanelComponent";

class UserDemographicInfoEditComponentState {
    public isPhoneValid: boolean;
    public isEmailValid: boolean;
    public isFirstNameValid: boolean;
    public isLastNameValid: boolean;
    public canSaveDemographics: boolean;
}

class UserDemographicInfoEditComponent extends React.Component<BaseEditableUserInfoPanelProps, UserDemographicInfoEditComponentState> {
    private readonly validationHelper = new ValidationHelper();
    private readonly c1Paddingtop: React.CSSProperties = { paddingTop: "5px", width: "190px" };

    constructor(props: BaseEditableUserInfoPanelProps) {
        super(props);

        const initialState = new UserDemographicInfoEditComponentState();
        const user = props.editedUser;
        initialState.isPhoneValid = false;
        initialState.isEmailValid = false;
        initialState.isFirstNameValid = user ? !IsNullOrWhiteSpace(user.Model.FirstName) : false;
        initialState.isLastNameValid = user ? !IsNullOrWhiteSpace(user.Model.LastName) : false;
        initialState.isPhoneValid = user ? user.isPhoneValid() : false;
        initialState.isEmailValid = user ? user.isEmailValid() : false;
        initialState.canSaveDemographics = this.isValid(initialState);
        this.state = initialState;
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
        this.initEmailAndPhoneNumber();
    }

    public componentDidUpdate(prevProps: BaseEditableUserInfoPanelProps): void {
        const user = this.props.editedUser;

        if (this.props.editedUser !== prevProps.editedUser) {
            this.mutateState(s => {
                s.isFirstNameValid = user ? !IsNullOrWhiteSpace(user.Model.FirstName) : false;
                s.isLastNameValid = user ? !IsNullOrWhiteSpace(user.Model.LastName) : false;
                s.isPhoneValid = user ? user.isPhoneValid() : false;
                s.isEmailValid = user ? user.isEmailValid() : false;
            });
        }
    }

    public render(): JSX.Element {
        return (
            <div className="user-component">
                <div className="flex-container heading" style={{ "borderBottom": "solid 1px #ccc", "margin": "20px 25px" }}>
                    <div className="h">
                        <h3 className="thin-font">{cacheStore.GetString("UserInformationLabel")}</h3>
                    </div>
                </div>
                <div className="patient-profile fxd-wdth-container">
                    <div className="tb">

                        {this.leftSide()}
                        {this.rightSide()}

                    </div>
                </div>
            </div>
        );
    }

    private leftSide(): JSX.Element {
        let employee = this.props.editedUser;

        return (
            <div className="tbc left">
                <div>
                    <table>
                        <tbody>
                            {employee.Type !== EmployeeType.Api && (
                                <tr>
                                    <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("PrefixLabel")}</label></td>
                                    <td className="c2">
                                        <SelectLookupControl
                                            Value={!IsNullOrUndefined(employee.Model.PrefixLookupId)
                                                ? employee.Model.PrefixLookupId
                                                : cacheStore.GetPrefixIndividualLookups().filter(p => p.LookupCode == "PREFIX.EMPTY").firstOrDefault().LookupID
                                            }
                                            AvailableValues={cacheStore.GetPrefixIndividualLookups().map(p => p.ToComboboxItem())}
                                            Callback={e => this.props.mutateParentEmployee(emp => emp.Model.PrefixLookupId = e)}
                                            dataCy="userProfile-demographicsPrefix"
                                        />
                                    </td>
                                </tr>
                            )}
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("FirstNameLabel")}</label></td>
                                <td className="c2">
                                    <TextboxControl
                                        valid={this.state.isFirstNameValid}
                                        id="firstNameEdit"
                                        value={employee.Model.FirstName ? employee.Model.FirstName : ""}
                                        className="form-control"
                                        onChange={e => this.props.mutateParentEmployee(emp => emp.Model.FirstName = e)}
                                        dataCy="userProfile-demographicsFirstName"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("LastNameLabel")}</label></td>
                                <td className="c2">
                                    <TextboxControl
                                        valid={this.state.isLastNameValid}
                                        id="lastNameEdit"
                                        value={employee.Model.LastName ? employee.Model.LastName : ""}
                                        className="form-control"
                                        onChange={e => this.props.mutateParentEmployee(emp => emp.Model.LastName = e)}
                                        dataCy="userProfile-demographicsLastName"
                                    />
                                </td>
                            </tr>
                            {employee.Type !== EmployeeType.Api && (
                                <>
                                    <tr>
                                        <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("MiddleNameLabel")}</label></td>
                                        <td className="c2">
                                            <TextboxControl
                                                id="middleNameEdit"
                                                value={employee.Model.MiddleName ? employee.Model.MiddleName : ""}
                                                className="form-control"
                                                onChange={e => this.props.mutateParentEmployee(emp => emp.Model.MiddleName = e)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("SuffixLabel")}</label></td>
                                        <td className="c2">
                                            <SelectLookupControl
                                                IncludeEmptyChoice={true}
                                                Value={employee.Model.SuffixLookupId ?? ""}
                                                AvailableValues={cacheStore.GetSuffixIndividualLookups().map(x => x.ToComboboxItem())}
                                                Callback={e => this.props.mutateParentEmployee(emp => emp.Model.SuffixLookupId = e)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("MaidenNameDLabel")}</label></td>
                                        <td className="c2">
                                            <TextboxControl id="maidenNameEdit" value={employee.Model.MaidenName ? employee.Model.MaidenName : ""} className="form-control" onChange={e => this.props.mutateParentEmployee(emp => emp.Model.MaidenName = e)} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("SecondNameLabel")}</label></td>
                                        <td className="c2">
                                            <TextboxControl id="secondNameEdit" value={employee.Model.SecondName ? employee.Model.SecondName : ""} className="form-control" onChange={e => this.props.mutateParentEmployee(emp => emp.Model.SecondName = e)} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.c1Paddingtop}>
                                            <label className="form-label">{cacheStore.GetString("SexLabel")}</label>
                                        </td>
                                        <td className="c2">
                                            <SelectLookupControl
                                                IncludeEmptyChoice={true}
                                                Value={employee.Model.GenderLookupId ? employee.Model.GenderLookupId : ""}
                                                AvailableValues={cacheStore.GetGenderLookups().map(x => x.ToComboboxItem())}
                                                Callback={e => this.props.mutateParentEmployee(emp => emp.Model.GenderLookupId = e)}
                                                dataCy="userProfile-demographicsGender"
                                            />
                                        </td>
                                    </tr>
                                </>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    private rightSide(): JSX.Element {
        const employee = this.props.editedUser;

        if (employee.Type === EmployeeType.Api)
            return <div className="tbc right" />;

        const extensionRegex = new RegExp("^[0-9]+$");

        const validationRule = this.validationHelper.getPhoneNumberValidationRule(employee.Model?.Phones?.firstOrDefault()?.CountryLookupId, null);

        const extensionValid = !employee.Model.Phones?.firstOrDefault() || extensionRegex.test(employee.Model.Phones[0]?.Extension);

        return (
            <div className="tbc right">
                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}>
                                    <span className="float-right"> {cacheStore.GetString("CountryLabel")}</span>
                                </td>
                                <td className="c2">
                                    <CountrySelect
                                        dataCy="user-demographic-country-select"
                                        onCountryChange={value => this.props.mutateParentEmployee(employeeModel => employeeModel.setPhoneCountry(value))}
                                        initialCountryLookupId={employee.Model.Phones?.[0]?.CountryLookupId}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("PhoneLabel")}</label></td>
                                <td className="c2">
                                    <div className="flex-container" style={{ justifyContent: "flex-start" }}>
                                        <div style={{ width: "80%" }}>
                                            <TextboxMaskedControl
                                                isValid={this.state.isPhoneValid}
                                                id="phoneNumber_id"
                                                value={employee.Model?.Phones?.firstOrDefault()?.Number ?? ""}
                                                onChangeFunction={(unmasked: string) => this.editPhoneNumber(unmasked)}
                                                mask={validationRule?.EditMaskPattern ?? ""}
                                                validationErrorMessage={cacheStore.GetLocalizedValueByLookupId(validationRule?.ValidationErrorMessageLookupId)}
                                                focus={this.props.model.get("IsModifyPhoneMode")}
                                            />
                                        </div>

                                        <div className="flex-container" style={{ justifyContent: "flex-start", marginLeft: "20px" }}>
                                            <div style={{ textAlign: "right", paddingTop: "5px", marginRight: "5px", whiteSpace: "nowrap", overflow: "hidden" }}>
                                                <div className="form-label">{cacheStore.GetString("ExtLabel")}</div>
                                            </div>

                                            <div style={{ width: "85px", marginLeft: "10px" }}>
                                                <TextboxControl
                                                    valid={extensionValid}
                                                    id="phoneExt"
                                                    maxLength={7}
                                                    value={employee.Model.Phones?.firstOrDefault()?.Extension ?? ""}
                                                    onChange={extension => this.props.mutateParentEmployee(emp => emp.Model.Phones[0].Extension = extension)}
                                                    item={null}
                                                    disabled={!(!IsNullOrWhiteSpace(employee.Model.Phones?.firstOrDefault()?.Number) && this.state.isPhoneValid)}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="c1" style={{ "verticalAlign": "top", "width": "190px" }}><label style={{ "paddingTop": "8px" }} className="form-label">{cacheStore.GetString("EmailLabel")}</label></td>
                                <td className="c2">
                                    {this.renderEmails()}
                                </td>
                            </tr>
                            {employee.Type === EmployeeType.Practician && (
                                <tr>
                                    <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("OnlineFirstNameLabel")}</label></td>
                                    <td className="c2">
                                        <TextboxControl
                                            id="OnlineFirstNameEdit"
                                            value={employee.Model.OnlineFirstName ?? ""}
                                            className="form-control"
                                            onChange={value => this.props.mutateParentEmployee(emp => emp.Model.OnlineFirstName = value)}
                                        />
                                    </td>
                                </tr>
                            )}
                            {employee.Type === EmployeeType.Practician && (
                                <tr>
                                    <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("OnlineLastNameLabel")}</label></td>
                                    <td className="c2">
                                        <TextboxControl
                                            id="OnlineLastNameEdit"
                                            value={employee.Model.OnlineLastName ?? ""}
                                            className="form-control"
                                            onChange={value => this.props.mutateParentEmployee(emp => emp.Model.OnlineLastName = value)}
                                        />
                                    </td>
                                </tr>
                            )}
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("ProfessionalDescriptionLabel")}</label></td>
                                <td className="c2">
                                    <TextboxControl
                                        id="DescriptionEdit"
                                        value={employee.Model.DescriptionProfessional ? employee.Model.DescriptionProfessional : ""}
                                        className="form-control"
                                        onChange={value => this.props.mutateParentEmployee(emp => emp.Model.DescriptionProfessional = value)}
                                    />
                                </td>
                            </tr>
                            {(employee.Type === EmployeeType.Practician) && (
                                <tr>
                                    <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("biographyLabel")}</label></td>
                                    <td className="c2">
                                        <TextAreaResizable
                                            style={{ width: "100%" }}
                                            id="demographicEdit_Employee_Biography"
                                            minHeightPx={130}
                                            isDisabled={false}
                                            onChange={value => this.onBiographyChange(value)}
                                            text={employee.Model.Biography ? employee.Model.Biography : ""}
                                            verticalResizeOnly={true}
                                            setCursorStartOnFocus={false}
                                            resetTextOnIdChange={true}
                                        />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    private renderEmails(): JSX.Element {
        let employee = this.props.editedUser;

        if (!employee.Model.Emails || employee.Model.Emails.length == 0) {
            return (<div />);
        }

        let emailValidationRule = new ValidationHelper().getEmailValidationRule();
        let emailMask: string = emailValidationRule ? emailValidationRule.EditMaskPattern : "";
        let emailValidationErrorMessage: string = (emailValidationRule && emailValidationRule.ValidationErrorMessageLookupId) ? cacheStore.GetLocalizedValueByLookupId(emailValidationRule.ValidationErrorMessageLookupId) : "";

        let emailsRender: JSX.Element[] = [];

        const firstEmailIndex = 0;

        let currentEmail = employee.Model.Emails[firstEmailIndex];

        let emailDetails: JSX.Element = (
            <tbody key="email">
                <tr>
                    <td>
                        <div className="row">
                            <div className="col-lg-12">
                                <TextboxMaskedControl
                                    isValid={currentEmail.IsValid}
                                    allowEmpty={false}
                                    alphanumericIncludesPeriod={false}
                                    returnMaskedValue={true}
                                    id="email"
                                    value={currentEmail.Address}
                                    onChangeFunction={e => this.props.mutateParentEmployee(emp => emp.onChangeEmailAddress(firstEmailIndex, e))}
                                    item={currentEmail}
                                    mask={emailMask}
                                    validationErrorMessage={emailValidationErrorMessage}
                                    isEmail={true}
                                    focus={this.props.model.get("IsModifyEmailMode")}
                                />
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td style={{ paddingTop: "5px" }}>
                        <CheckboxControl
                            id="chkIsOk"
                            checked={currentEmail.IsOkToContact}
                            label={cacheStore.GetString("OkToContactLabel")}
                            onChange={() => this.props.mutateParentEmployee(emp => emp.onChangeIsOkToContact(firstEmailIndex))}
                            item={currentEmail}
                        />
                    </td>
                </tr>
                <tr>
                    <td>
                        <CheckboxControl
                            checked={employee.Model.IsSendNotificationByEmail ? employee.Model.IsSendNotificationByEmail : false}
                            label={cacheStore.GetString("SendUpdateNotificationByEmailLabel")}
                            onChange={(isChecked: boolean) => this.props.mutateParentEmployee(emp => emp.setSendNotification(isChecked))}
                            disabled={IsNullOrWhiteSpace(currentEmail.Address) || !currentEmail.IsValid}
                        />
                    </td>
                </tr>
            </tbody>
        );

        emailsRender.push(emailDetails);

        return (
            <div>
                <div className="email-address fxd-wdth-container edit">
                    <div className="tb">
                        <div className="tbc left">
                            <div>
                                <table>
                                    {emailsRender}
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private mutateState(mutation: (s: UserDemographicInfoEditComponentState) => void, then?: () => void): void {
        const s = new UserDemographicInfoEditComponentState();
        mutation(s);

        s.canSaveDemographics = this.isValid(s);

        this.setState(s, () => {
            this.props.isValidCallBack?.(s.canSaveDemographics);
            then?.();
        });
    }

    private initEmailAndPhoneNumber(): void {
        const user = this.props.editedUser;

        this.props.mutateParentEmployee(emp => {
            if (!user.Model.Emails?.length)
                emp.onAddEmail();
            else if (!user.Model.Emails[0].renderId)
                emp.initializeEmails();

            if (!user.Model.Phones?.length)
                emp.onAddPhone();
            else if (!user.Model.Phones[0].renderId)
                emp.initializePhones();
        });
    }

    private editPhoneNumber(unmasked: string): void {
        this.props.mutateParentEmployee(emp => emp.setPhone(unmasked));
    }

    private onBiographyChange(value: string): void {
        this.props.mutateParentEmployee(emp => emp.Model.Biography = value);
    }

    private isValid(s: UserDemographicInfoEditComponentState): boolean {
        return s.isLastNameValid
            && s.isFirstNameValid
            && s.isPhoneValid
            && s.isEmailValid;
    }
}

export { UserDemographicInfoEditComponent };
